// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__13xSJ","large":"styles_large___3Pi4"};